/******APP******/

/***GENERAL***/
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router";

/***FUNCTIONS***/
import { initURLS } from "./00-Appendix.js";

/***PAGES & COMPONENTS***/
import Header from "./02-Header.jsx";
import Carousel from "./03-Carousel.jsx";
import Homepage from "./04-Homepage.jsx";
import Realisations from "./05-Realisations.jsx";
import Partenaires from "./06-Partenaires.jsx";
import PageFooter from "./07-PageFooter.jsx";
import Contact from "./08-Contact.jsx";
import PageProjet from "./10-PageProjet.jsx";
import Newsletter from "./11-Newsletter.jsx";
import Invitation from "./12-Invitation.jsx";
import UniForm from "./UniForm.jsx";
import CedForm from "./CedForm.jsx";
import CedForm2 from "./CedForm2.jsx";
import CedForm3 from "./CedForm3.jsx";


/***DATAS***/
import data from "./data/real.json";
import data2 from "./data/part.json";

/***APP***/

export default function App() {
  //DOM
  return (
    <Router>
      <div className="app">
        {/*ROUTES*/}
        <Switch>
          {/*ACCUEIL*/}
          <Route exact path="/accueil">
            <Header />
            <Carousel />
            <Homepage />
            <PageFooter />
          </Route>
          {/*Enseignements Numeriques*/}
          <Route exact path="/enseignement-numerique">
            <Header />
            <Realisations data={data} />
            <PageFooter />
          </Route>
          {/*Campus augmenté*/}
          <Route exact path="/campus-augmente">
            <Header />
            <Realisations data={data} />
            <PageFooter />
          </Route>
          {/*Simplification Administrative*/}
          <Route exact path="/simplification-administrative">
            <Header />
            <Realisations data={data} />
            <PageFooter />
          </Route>
          {/*Partenaires*/}
          <Route exact path="/partenaires">
            <Header />
            <Partenaires data={data2} />
            <PageFooter />
          </Route>
          {/*Contact*/}
          <Route exact path="/contact">
            <Header />
            <Contact />
            <PageFooter />
          </Route>
          {/*newsletter*/}
          <Route exact path="/newsletter">
            <Newsletter />
          </Route>
          {/*formulaire UNIBOT*/}
          <Route exact path="/formulaire-UNIBOT">
            <UniForm />
          </Route>
                    {/*formulaire CED*/}
          <Route exact path="/formulaire-CED">
            <CedForm />
          </Route>
                        {/*formulaire CED 2*/}
          <Route exact path="/formulaire-CED-consentement">
            <CedForm2 />
          </Route>
          {/*formulaire CED 3*/}
          <Route exact path="/formulaire-CED-fiche-projet">
            <CedForm3 />
          </Route>
          {/*Projet UNIBOT : formulaire de consentement 1{Invitation*/}
          <Route exact path="/invitation">
            <Invitation />
          </Route>
          {/*PageProjet*/}
          {initURLS(data).map((item) => (
            <Route key={"1-" + item} exact path={"/realisation/" + item}>
              <Header />
              <PageProjet data={data} />
              <PageFooter />
            </Route>
          ))}
          {/*REDIRECT*/}
          <Route>
            <Redirect to="/accueil" />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}
